import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import FAQSection from './components/FAQSection';
import CarouselSection from './components/CarouselSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <RankingSection />
        <AppSection />
        <ContactSection />
        <TopicsSection />
        <CommentsSection />
        <FeaturesSection />
        <CardsSection />
        <UpdatesSection />
        <IndexSection />
        <MediaSection />
        <FAQSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}